import { Link } from "react-router-dom";
import { ArrowRight, Users, GitBranch, ClipboardCheck, ShieldCheck } from "lucide-react";
import Nav from "@/components/marketing/Nav";
import Footer from "@/components/marketing/Footer";
import { Reveal, RevealGroup, Item } from "@/components/Reveal";

const features = [
  { Icon: Users, title: "Client directory", body: "Every client and their cases in one place, scoped strictly to your organization." },
  { Icon: GitBranch, title: "Case pipeline", body: "See every case by readiness state, who owns it and what is blocking progress." },
  { Icon: ClipboardCheck, title: "Review queue", body: "Cases waiting for review, sorted so nothing slips through the cracks." },
  { Icon: ShieldCheck, title: "Data privacy & audit trail", body: "Strong permission boundaries keep each agency's data private, with an audit trail on material actions." },
];

export default function ForAgencies() {
  return (
    <div className="min-h-screen bg-softcream">
      <Nav />
      <section className="mx-auto max-w-page px-5 py-16 sm:px-8 sm:py-20 md:py-28 lg:px-12">
        <Reveal>
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.2em] text-coral sm:text-base">For agencies</p>
          <h1 className="max-w-3xl font-serif text-4xl leading-tight tracking-tight text-heading sm:text-5xl md:text-6xl">Operational control across every client and case.</h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted sm:text-lg">Stop managing cases in spreadsheets and message threads. Holavisto gives your team a desktop-first workspace built around the real preparation workflow.</p>
        </Reveal>
        <RevealGroup className="mt-12 grid gap-6 sm:grid-cols-2">
          {features.map((f) => (
            <Item key={f.title} className="group rounded-md border border-hborder bg-white p-6 transition-all duration-300 sm:p-7" data-testid={`agency-feature-${f.title.toLowerCase().split(" ")[0]}`}>
              <span className="inline-grid h-12 w-12 place-items-center rounded-md bg-ltblue transition-transform duration-300 "><f.Icon className="text-tblue" size={22} /></span>
              <h2 className="mt-4 text-xl font-semibold text-heading">{f.title}</h2>
              <p className="mt-1.5 text-[15px] leading-relaxed text-muted">{f.body}</p>
            </Item>
          ))}
        </RevealGroup>
        <Reveal className="mt-12 rounded-md bg-navy p-6 text-center text-white sm:p-8">
          <h2 className="font-serif text-2xl sm:text-3xl">Join the agency beta</h2>
          <p className="mx-auto mt-2 max-w-xl text-white/75">The agency workspace is in active beta. Sign in with a provided agency account to explore the pipeline, clients and review queue.</p>
          <Link to="/login" className="mt-6 inline-flex items-center gap-2 rounded bg-brandyellow px-7 py-3.5 text-sm font-semibold text-heading transition-all duration-300 " data-testid="agencies-signin-btn">
            Sign in to the agency workspace <ArrowRight size={16} />
          </Link>
        </Reveal>
      </section>
      <Footer />
    </div>
  );
}
